import { createFileRoute, Outlet } from '@tanstack/react-router';

import { SidebarContent } from '@/components/routing/SidebarContent';

export const Route = createFileRoute('/_map/_sidebar')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SidebarContent>
      <Outlet />
    </SidebarContent>
  );
}
